/**
 * @module components/XAxisSetting/XAxisTopN
 * @description X 轴 TopN — 饼图始终展示；柱状/堆叠/百分比堆叠/折线需分类维度 > 1
 */
import React, { useMemo } from 'react';
import { useIntl } from 'umi';
import { ChartType } from '@dbl/core/chart';
import TipContext from '@home/components/TipContext';
import TopNFieldGroup from '../common/TopNFieldGroup';
import { useQuerySelector } from '../../hooks/deps';
import { toChartTypeEnum } from '../../utils/toChartTypeEnum';
import { useXAxisTopNDraftFields } from './useXAxisTopNDraftFields';
import './XAxisTopN.scss';

const XAxisTopN: React.FC = () => {
  const { formatMessage } = useIntl();
  const chartTypeStr = useQuerySelector(s => s.chartType as string);
  const chartType = useMemo(
    () => toChartTypeEnum(chartTypeStr),
    [chartTypeStr],
  );

  const defaultDynamicState = chartType === ChartType.Pie;
  const topN = useXAxisTopNDraftFields(5, defaultDynamicState);

  return (
    <div className="dbl-x-axis-topn">
      <div className="dbl-x-axis-topn__header">
        <span className="dbl-x-axis-topn__title">
          {formatMessage({ id: 'dbl_chart_top' })}
        </span>
        <TipContext
          tipText={formatMessage(
            { id: 'dbl_chart_topN_info' },
            { type: 'X' },
          )}
        />
      </div>
      <TopNFieldGroup
        {...topN}
        countLimitTip={formatMessage({ id: 'dbl_myAnalysis_limit_100' })}
      />
    </div>
  );
};

export default React.memo(XAxisTopN);

